module.exports = __webpack_public_path__ + "static/media/cat.63003ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat.jpg
// module id = 32
// module chunks = 0